import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withModifiers as _withModifiers, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createVNode as _createVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "apollo-link pointer" }
const _hoisted_2 = { class: "contact-card" }
const _hoisted_3 = { class: "title" }
const _hoisted_4 = { class: "contact-fields" }
const _hoisted_5 = { key: 3 }
const _hoisted_6 = { key: 4 }
const _hoisted_7 = { key: 3 }
const _hoisted_8 = { key: 4 }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_Icon = _resolveComponent("Icon")
  const _component_Loader = _resolveComponent("Loader")
  const _component_Popover = _resolveComponent("Popover")

  return (_openBlock(), _createBlock(_component_Popover, {
    ref: "popover",
    class: "popover-wrapper",
    "popper-class": "apollo-popover",
    teleported: "",
    mask: _ctx.$responsive.mobile,
    placement: "bottom-start",
    trigger: "hover",
    "show-arrow": false,
    "show-after": 200,
    persistent: false,
    "z-index": 3000
  }, {
    reference: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, _toDisplayString($props.text), 1 /* TEXT */)
    ]),
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("span", null, _toDisplayString($options.info_title), 1 /* TEXT */),
          (_ctx.$responsive.mobile)
            ? (_openBlock(), _createBlock(_component_Icon, {
                key: 0,
                class: "mobile-close pointer",
                icon: "x-close",
                size: "2rem",
                stroke: "var(--gray-500)",
                onClick: _cache[0] || (_cache[0] = _withModifiers($event => (_ctx.$refs.popover.hide()), ["stop"]))
              }))
            : _createCommentVNode("v-if", true)
        ]),
        _createElementVNode("div", _hoisted_4, [
          ($options.email_field)
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                class: _normalizeClass(["card-content", {pointer: !$data.loading}]),
                onClick: _cache[1] || (_cache[1] = $event => (!$data.loading && $options.onEmail()))
              }, [
                ($data.loading)
                  ? (_openBlock(), _createBlock(_component_Loader, {
                      key: 0,
                      class: "loading",
                      inline: "",
                      mini: ""
                    }))
                  : ($options.c_email)
                    ? (_openBlock(), _createBlock(_component_Icon, {
                        key: 1,
                        icon: "copy",
                        stroke: "var(--brand-700)",
                        size: $options.icon_size
                      }, null, 8 /* PROPS */, ["size"]))
                    : (_openBlock(), _createBlock(_component_Icon, {
                        key: 2,
                        icon: "mail-question",
                        stroke: "var(--brand-700)",
                        size: $options.icon_size
                      }, null, 8 /* PROPS */, ["size"])),
                ($options.c_email)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_5, _toDisplayString($options.c_email), 1 /* TEXT */))
                  : (_openBlock(), _createElementBlock("span", _hoisted_6, "Get Email"))
              ], 2 /* CLASS */))
            : _createCommentVNode("v-if", true),
          ($options.phone_field)
            ? (_openBlock(), _createElementBlock("div", {
                key: 1,
                class: _normalizeClass(["card-content", {pointer: !$data.loading}]),
                onClick: _cache[2] || (_cache[2] = $event => (!$data.loading && $options.onPhone()))
              }, [
                ($data.loading)
                  ? (_openBlock(), _createBlock(_component_Loader, {
                      key: 0,
                      class: "loading",
                      inline: "",
                      mini: ""
                    }))
                  : ($options.c_phone)
                    ? (_openBlock(), _createBlock(_component_Icon, {
                        key: 1,
                        icon: "copy",
                        stroke: "var(--brand-700)",
                        size: $options.icon_size
                      }, null, 8 /* PROPS */, ["size"]))
                    : (_openBlock(), _createBlock(_component_Icon, {
                        key: 2,
                        icon: "phone",
                        stroke: "var(--brand-700)",
                        size: $options.icon_size
                      }, null, 8 /* PROPS */, ["size"])),
                ($options.c_phone)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_7, _toDisplayString($options.c_phone), 1 /* TEXT */))
                  : (_openBlock(), _createElementBlock("span", _hoisted_8, "Get Phone"))
              ], 2 /* CLASS */))
            : _createCommentVNode("v-if", true),
          ($data.linkedin)
            ? (_openBlock(), _createElementBlock("div", {
                key: 2,
                class: "card-content pointer",
                onClick: _cache[3] || (_cache[3] = $event => ($options.openLinkedin()))
              }, [
                _createVNode(_component_Icon, {
                  icon: "social/linkedin-circle",
                  class: "ln-icon",
                  size: $options.icon_size
                }, null, 8 /* PROPS */, ["size"]),
                _cache[4] || (_cache[4] = _createElementVNode("span", null, "Go to LinkedIn", -1 /* HOISTED */))
              ]))
            : _createCommentVNode("v-if", true)
        ])
      ])
    ]),
    _: 1 /* STABLE */
  }, 8 /* PROPS */, ["mask"]))
}